module.exports = __webpack_public_path__ + "static/media/password-icon-regular.681ed500.png";